import { PlaceOutlined } from '@mui/icons-material'
import { Accordion, AccordionDetails, Grid } from '@mui/material'

import buildingIcon from '../../../images/building-icon.svg'
import useStyles from '../index.styles'

import AccordionGroup from './accordion-group'

const NO_BUILDING_GROUP = 'No Building Assigned'

const AccordionGroupBuilding = ({
  building,
  buildingContent,
  isExpanded,
  onToggle,
}: {
  building: IBuildingGroup
  buildingContent: React.ReactNode
  isExpanded: boolean
  onToggle: (key: string) => (event: React.SyntheticEvent, newExpanded: boolean) => void
}) => {
  const classes = useStyles

  return (
    <Accordion data-testid="accordion" expanded={isExpanded} onChange={onToggle(building.name)} sx={[classes.accordion, classes.firstLevelAccordion]}>
      <AccordionGroup.SummaryTopLevel
        label={building.name}
        count={building.floors.reduce((sum, f) => sum + f.devices.length, 0)}
        hasAlert={building.hasAlert}
        icon={building.name === NO_BUILDING_GROUP ? <PlaceOutlined sx={classes.placeIcon} /> : <img src={buildingIcon} alt="" style={classes.groupIcon} />}
      />
      <AccordionDetails sx={classes.accordionDetails}>
        <Grid container={true} size={12} sx={classes.deviceGroupDetailsContainer}>
          {buildingContent}
        </Grid>
      </AccordionDetails>
    </Accordion>
  )
}

export default AccordionGroupBuilding
